'use client'

import {Section} from "@/components/atoms/sections";
import {LodgingBooking} from "@/lib/types";
import {useGetLodgingBookingsQuery} from "@/lib/client/slices/lodgings";
import {DateFormat} from "@/components/atoms/datetime";
import {NeutralMessage, SmallTitle} from "@/components/atoms/typographies";
import {SDivider} from "@/components/atoms/divider";


function BookingRow({booking}: { booking: LodgingBooking }) {


  return <div className="flex flex-row justify-around border-b border-gray-200">
    <div className="block p-2 flex-1 text-center">{DateFormat({date: booking.begin_at})}</div>
    <div className="block p-2 flex-1 text-center">{DateFormat({date: booking.end_at})}</div>
    <div className="block p-2 flex-1 text-center">{booking.available ? 'Disponible' : 'Indisponible'}</div>
    <div className="block p-2 flex-1 text-center">{booking.price / 100} €</div>
  </div>
}

export function BookingViews({id, type}: { id: string, type: string }) {
  const {data: bookings, ...status} = useGetLodgingBookingsQuery({id})

  return <>
    <Section>
      <SmallTitle>Disponibilités</SmallTitle>
      <SDivider/>


      {bookings && <div>
          <div className="flex flex-row justify-around border-b border-gray-200">
              <div className="block p-2 font-semibold flex-1 text-center">Date de début</div>
              <div className="block p-2 font-semibold flex-1 text-center">Date de fin</div>
              <div className="block p-2 font-semibold flex-1 text-center">Disponibilité</div>
              <div className="block p-2 font-semibold flex-1 text-center">Tarif sur la période</div>
          </div>
        {bookings.map(b => <BookingRow key={'booking-' + b.id} booking={b}/>)}
      </div>
      }
      {bookings && bookings.length == 0 &&
          <NeutralMessage className={'text-center'}>Aucune disponibilité publiée.</NeutralMessage>}
    </Section>
  </>
}